import BeelditTypeSelector from "@beeldit/core/components/BeelditTypeSelector";
import ProducerSelector from "@main/producers/components/ProducerSelector";

const filterUIConfig = {
  uiScheme: {
    "ui:classNames": "filters-container",

    search: {
      "ui:options": {
        label: false, // Oculta el título del campo
        placeholder: "Buscar...",
      },
    },
    emitter_id: {
      "ui:widget": ProducerSelector,
      "ui:options": {
        label: false,
      },
    },
    status: {
      "ui:options": {
        label: false,
      },
    },
  },
};
const getFilterUIConfig: any = (type: string) => {
  return filterUIConfig;
};
export default getFilterUIConfig;
